<template>
  <div class="sp-template">
    <div class="h-title">到货订单</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="客户">
              <el-select v-model="queryForm.customerIds" filterable clearable multiple placeholder="选择客户">
                <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道">
              <el-select v-model="queryForm.productIds" filterable clearable multiple placeholder="选择渠道">
                <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input type="textarea" v-model="orderIds" placeholder="多个订单号用回车分割"></el-input>
            </el-form-item>
          </el-row>
          <el-collapse-transition>
            <div v-show="isSearchMore">
              <el-row>
                <el-form-item label="仓库">
                  <el-select v-model.lazy="queryForm.warehouseIds" filterable clearable multiple>
                    <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="客户单号">
                  <el-input type="textarea" v-model="refNumbers" placeholder="多个客户单号用回车分割"></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="开始日期">
                  <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                  <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
                </el-form-item>
              </el-row>
            </div>
          </el-collapse-transition>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(40212)" type="primary" size="small" @click="searchTask()">搜索</el-button>
            <el-button v-if="in_configs(40212)" size="small" @click="reset()">清空</el-button>
            <a class="toggle-icon" @click.stop.prevent="isSearchMore = !isSearchMore">
							<b v-show="isSearchMore">隐藏</b><b v-show="!isSearchMore">展开</b>更多搜索条件
            </a>
          </div>
        </el-form>
        <div>
          <!-- 批量收货 -->
          <!-- <el-button v-if="in_configs(40201) && queryForm.status == 0" size="small" class="btn-cyan" @click="dialogGoodsFormMoreVisible = true">批量收货</el-button> -->
          <!-- <el-button v-if="in_configs(40202)  && queryForm.status == 1 " size="small" type="primary">下载签收单</el-button> -->
          <!-- <el-button v-if="in_configs(40203) &&queryForm.status ==-1 " size="small" type="success" @click="handleChangeMore">转为正常单</el-button> -->
          <!-- <el-button v-if="in_configs(40204)" size="small" type="warning">下载面单</el-button> -->
          <!-- <router-link v-if="in_configs(40205)" to="/orderoperation/claimlist">
            <el-button size="small">认领列表</el-button>
          </router-link> -->
        </div>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="queryForm.status" @tab-click="searchTask">
					<el-tab-pane v-if="in_configs(40209)" label="待处理" name="0"></el-tab-pane>
					<el-tab-pane v-if="in_configs(40210)" label="完成" name="1"></el-tab-pane>
					<el-tab-pane v-if="in_configs(40211)" label="异常" name="-1"></el-tab-pane>
				</el-tabs>
        <div class="button-groups">
          <router-link tag="el-button" v-if="in_configs(40213)" class="el-button--small" :to="{path: '/orderoperation/claimlist', query: {from: 'orderoperation/arrivalgoods'}}">认领清单</router-link>
        </div>
      </div>
      <el-table :data="tableData" border stripe style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column label="仓库">
          <template slot-scope="scope">
            {{warehouseMap[scope.row.warehouseCode]}}
          </template>
        </el-table-column>
        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>
        <el-table-column label="渠道">
          <template slot-scope="scope">
            {{channelsMaps[scope.row.product]}}
          </template>
        </el-table-column>
        <el-table-column prop="refNumber" label="客户单号"></el-table-column>
        <el-table-column prop="totalCarton" label="预报箱数"></el-table-column>
        <el-table-column prop="doneCarton" v-if=" queryForm.status != '-1' " label="已到货箱数"></el-table-column>
        <el-table-column prop="createAt" label="预报时间"></el-table-column>
        <el-table-column v-if=" queryForm.status == '-1' " prop="errorMsg" label="异常信息"></el-table-column>
        <el-table-column v-if=" queryForm.status =='-1' " prop="operator" label="操作人"></el-table-column>
        <el-table-column v-if=" queryForm.status =='-1' " prop="operateAt" label="操作时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" v-if="in_configs(40206) && queryForm.status == '0' " type="text" @click="handleGoods(scope.$index, scope.row)">收货</el-button>
            <el-button size="mini" v-if="in_configs(40207) && queryForm.status == '1' " type="text" @click="handleDownload(scope.$index, scope.row)">下载签收单</el-button>
            <el-button size="mini" v-if="in_configs(40203) && queryForm.status != '1' " type="text" @click="handleArrivalToEditOrder( scope.row)">编辑</el-button>
            <el-button size="mini" v-if="queryForm.status == '-1' " type="text" @click="exceptionLook( scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
      <!-- 批量收货弹窗 -->
      <el-dialog title="批量收货" :visible.sync="dialogGoodsFormMoreVisible">
        <el-form :model="goodsFormMore" size="small">
          <el-form-item label="仓库名称" label-width="120px">
            <el-select v-model="goodsFormMore.test" placeholder="仓库名称">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件上传" label-width="120px">
            <form action="FileUploadServlet" enctype="multipart/form-data" name="fileUploadForm" class="el-input--small">
              <input type="file" ref="docFile" id="docFile" style="display: none;" onchange="document.fileUploadForm.filePath.value = this.value" />
              <input type="text" class="el-input__inner" style="width:200px;" name="filePath" id="filePath" />
              <input type="button" class="el-button el-button--small" value="游览" onclick="document.fileUploadForm.docFile.click()" /><br/>
              <a href="javascript:;">
                <el-button size="small" type="text">下载模板</el-button>
              </a>
            </form>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogGoodsFormMoreVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="dialogGoodsFormMoreVisible = false">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 收货弹出框 -->
      <el-dialog title="收货" :visible.sync="dialogGoodsFormVisible" :show-close='false' width="400px" class="fullwidth-form__dialog">
        <el-form :model="receiptForm" size="small" :rules="rule" id="uploadForm" label-width="80px" label-position="left">
          <el-form-item label="客户名称">{{receiptForm.customerName}}</el-form-item>
          <el-form-item label="订单号">{{receiptForm.orderId}}</el-form-item>
          <el-form-item label="收货仓库">
            <el-select v-model.lazy="receiptForm.warehouseId" filterable clearable>
              <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收货箱数" prop="actualArrivalQty">
            <el-input type="number" min="1" v-model.number="receiptForm.actualArrivalQty" auto-complete="off" @blur="checkArrival"></el-input>
          </el-form-item>
          <el-form-item label="未到的箱号" v-show="receiptForm.allArrival==0">
            <el-tag :key="tag" v-for="tag in receiptForm.arrivalCartonCodes" closable :disable-transitions="false" @close="handleArrivaledClose(tag)"> {{tag}}</el-tag>
            <el-input class="input-new-tag" v-if="inputVisible" v-model="arrivalCarton" ref="saveArrivaledTagInput" size="small" @keyup.enter.native="handleArrivaledInputConfirm" @blur="handleArrivaledInputConfirm"></el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showArrivaledInput">添加箱号</el-button>
          </el-form-item>
          <!-- <el-form-item label="箱子破损" label-width="120px" v-show="receiptForm.allArrival==0 || receiptForm.allArrival==1 ">
            <el-radio v-model="receiptForm.radio" :label="1">是</el-radio>
            <el-radio v-model="receiptForm.radio" :label="2">否</el-radio>
          </el-form-item> -->
          <el-form-item label="破损原因" v-show="receiptForm.radio == 1">
            <el-input v-model.trim="receiptForm.reason" placeholder="破损说明"></el-input>
          </el-form-item>
          <el-form-item label="破损箱号" v-show="receiptForm.radio == 1">
            <el-tag :key="tag" v-for="tag in receiptForm.exceptionCartonCodes" closable :disable-transitions="false" @close="handleExceptionClose(tag)"> {{tag}}</el-tag>
            <el-input class="input-new-tag" v-if="inputVisible1" v-model="exceprtionCarton" ref="saveExceptionTagInput" size="small" @keyup.enter.native="handleExceptionInputConfirm" @blur="handleExceptionInputConfirm"></el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showExceptionInput">添加箱号</el-button>
          </el-form-item>
          <el-form-item label="图片上传" v-show="receiptForm.radio == 1">
            <el-upload action="#" ref="upload" list-type="picture-card" accept=".jpg,.png,.jpeg" :on-change="handlePictureCardChange" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :auto-upload="false">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-dialog :visible.sync="dialogGoodsVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelReceipt">取 消</el-button>
          <el-button size="small" type="primary" @click="receiptDone">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 查看异常 -->

      <el-dialog title="异常信息" :visible.sync="dialogGoodsFormExceptionVisible">
        <el-table :data="exceptionCartonData" stripe>
          <el-table-column prop="cartonCode" label="箱号"></el-table-column>
          <el-table-column prop="imgUrl" label="图片">
            <template slot-scope="scope">
              <sp-img :url-arr="scope.row.imgUrl" show-one @get-urlArr="getUrlArr" @active-index="getActiveIndex" />
            </template>
          </el-table-column>
          <el-table-column prop="messages" label="异常信息"></el-table-column>
        </el-table>

        <sp-dialog :visible.sync="visiblePicture">
          <sp-img-content :urlArr="spImgArr" :activeIndex="activeIndex" @active-index="getActiveIndex"></sp-img-content>
        </sp-dialog>
      </el-dialog>
    </el-card>
    <!-- 转为正常单 -->
    <el-dialog title="处理异常" :visible.sync="dialogFormVisible" width="60%">
      <el-form :model="abnormaData" size="small" label-width="100px">
        <el-form-item label="异常类型">
          <el-select v-model.lazy="abnormaData.exceptionType">
            <el-option v-for="(d, i) in abnormalType" :key="i" :label="d.name" :value="d.value"></el-option>
          </el-select>
          <el-checkbox v-model.lazy="abnormaData.returnCarton" @change="changeReturnCarton">退回</el-checkbox>
          <el-tooltip class="item" effect="dark" content="可全部退回和部分退回" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
          <el-radio v-show='abnormaData.returnCarton' v-model.lazy="abnormaData.returnMethod" label="all_return">全部退回</el-radio>
          <el-radio v-show='abnormaData.returnCarton' v-model.lazy="abnormaData.returnMethod" label="part_return">部分退回</el-radio>
        </el-form-item>
        <el-form-item label="退货箱号" v-show="abnormaData.returnCarton && abnormaData.returnMethod =='part_return'" label-width="120px">
          <el-tag :key="tag" v-for="tag in abnormaData.partReturnCartonsList" closable :disable-transitions="false" @close="dealExcepptionArrivaledClose(tag)"> {{tag}}</el-tag>
          <el-input class="input-new-tag" v-if="inputVisible" v-model.trim="partReturnCartons" ref="saveArrivaledTagInput" size="small" @keyup.enter.native="handleReturnArrivaledInputConfirm" @blur="handleReturnArrivaledInputConfirm"></el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showReturnArrivaledInput">添加箱号</el-button>
        </el-form-item>
      </el-form>
      <el-form :model="abnormaData" size="small" v-show="abnormaData.returnMethod!='all_return' " label-width="100px">
        <h3 class="sp-card-title">{{abnormaData.exceptionType == 'less' ? '少箱' : '多箱'}}</h3>
        <el-form-item label="预报箱数">{{abnormaData.forecastNum}}</el-form-item>
        <el-form-item label="已收箱数">{{abnormaData.receiptNum}}</el-form-item>
        <el-form-item label="实际箱数">
          <el-input v-model.lazy="abnormaData.practicalNum"></el-input>
        </el-form-item>
        <el-form-item label="箱子规格" v-show="abnormaData.exceptionType == 'more'">
          <el-radio v-model="abnormaData.radio" label="1">全部相同</el-radio>
          <el-radio v-model="abnormaData.radio" label="2">不同</el-radio>
          <el-tooltip class="item" effect="dark" content="选全部相同则填写" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>

        <!-- 规格相同，只添加一箱sku信息 -->
        <el-form-item v-show=" abnormaData.radio =='1' && abnormaData.exceptionType == 'more'">
          <i class="el-icon-circle-plus-outline" @click="handleAddSku()">添加sku</i>
          <el-table :data="spList" tooltip-effect="dark" border style="width: 100%" class="table-upload">
            <el-table-column label="SKU">
              <template slot-scope="scope">
                <el-input v-model="scope.row.sku"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="中文品名">
              <template slot-scope="scope">
                <el-input v-model="scope.row.zhName"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="英文品名">
              <template slot-scope="scope">
                <el-input v-model="scope.row.enName"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="海关编码">
              <template slot-scope="scope">
                <el-input v-model="scope.row.code"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="申报价值">
              <template slot-scope="scope">
                <el-input v-model="scope.row.money"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <el-input v-model="scope.row.number"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="图片" width="120">
              <template slot-scope="scope">
                <p v-for="(d, i) in scope.row.skuArr" :key="i">
                  <el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card" :on-preview="handlePictureCardPreview2" :on-remove="handleRemove">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="SKU操作">
              <template slot-scope="scope">
                <i class="el-icon-delete" @click="handleDeleteSku(scope.$index,scope.row)"></i>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <i class="el-icon-circle-plus-outline" @click="handleAddSku()"></i>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- 箱规格不同 -->
        <el-form-item v-show=" abnormaData.radio =='2' && abnormaData.exceptionType == 'more' ">
          <!-- <i class="el-icon-circle-plus-outline" @click="handleAddCarton()">添加箱</i> -->
          <el-table :data="spCartonList" tooltip-effect="dark" border style="width: 100%" class="table-upload">
            <el-table-column label="箱序号">
              <template slot-scope="scope">
                {{scope.row.cartonIndex}}
              </template>
            </el-table-column>
            <el-table-column label="SKU">
              <template slot-scope="scope">
                <p v-for="(d, i) in scope.row.skuArr" :key="i">
                  <el-input v-model="d.sku"></el-input>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="中文品名">
              <template slot-scope="scope">
                <p v-for="(d, i) in scope.row.skuArr" :key="i">
                  <el-input v-model="d.zhName"></el-input>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="英文品名">
              <template slot-scope="scope">
                <p v-for="(d, i) in scope.row.skuArr" :key="i">
                  <el-input v-model="d.enName"></el-input>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="海关编码">
              <template slot-scope="scope">
                <p v-for="(d, i) in scope.row.skuArr" :key="i">
                  <el-input v-model="d.code"></el-input>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="申报价值">
              <template slot-scope="scope">
                <p v-for="(d, i) in scope.row.skuArr" :key="i">
                  <el-input v-model="d.money"></el-input>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <p v-for="(d, i) in scope.row.skuArr" :key="i">
                  <el-input v-model="d.number"></el-input>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="图片" width="120">
              <template slot-scope="scope">
                <p v-for="(d, i) in scope.row.skuArr" :key="i">
                  <el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card" :on-preview="handlePictureCardPreview2" :on-remove="handleRemove">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="SKU操作">
              <template slot-scope="scope">
                <p v-for="(d, i) in scope.row.skuArr" :key="i">
                  <i class="el-icon-delete" @click="handleDeleteCartonSku(i,scope.row.skuArr)"></i>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <i class="el-icon-circle-plus-outline" @click="handleAddCartonSku(scope.$index, scope.row.skuArr)"></i>
                <!-- <i class="el-icon-delete" @click="handleDeleteCarton(scope.$index, scope.row)"></i> -->
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
      <el-dialog :visible.sync="dialogVisible2" append-to-body>
        <img width="100%" :src="dialogImageUrl2" alt="">
      </el-dialog>
    </el-dialog>

    <el-dialog title="变更仓库" :visible.sync="dialogFormVisible1" width="30%">
      <el-form :model="editWarehouseForm" label-position="right" label-width="60px">
        <el-form-item label="订单号">
          {{editWarehouseForm.orderIds}}
        </el-form-item>
        <el-form-item label="仓库">
          <el-select v-model.lazy="editWarehouseForm.warehouseId" filterable clearable>
            <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="editWarehouse">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    var validArrivalQty = (rule, value, callback) => {
      setTimeout(() => {
        var pattern = /^[0-9]*[1-9][0-9]*$/;
        if (!pattern.test(value)) {
          callback(new Error("请输入正确的收货箱数"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      //穿梭框
      transferData: [
        { id: 1, label: "item1" },
        { id: 2, label: "item2" },
        { id: 3, label: "item3" },
        { id: 4, label: "item4" },
        { id: 5, label: "item5" }
      ],
      callbakData: [],
      dialogImageUrl2: "",
      dialogVisible2: false,
      dialogFormVisible: false,
      form: {
        type: "",
        checked: false
      },
      abnormalType: [
        { name: "少箱", value: "less" },
        { name: "多箱", value: "more" }
      ],
      spList: [],
      spCartonList: [],
      isSearchMore: false,
      inputVisible: false,
      partReturnCartons: "",
      abnormaData: {
        partReturnCartonsList: [],
        returnCarton: false,
        returnMethod: "part_return",
        exceptionType: "less",
        checked: false,
        forecastNum: "",
        receiptNum: "",
        practicalNum: "",
        radio: "1"
      },
      orderIds: "",
      refNumbers: "",
      queryForm: {
        warehouseIds: [],
        orderIds: [],
        refNumbers: [],
        status: "0",
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0
      },
      //表单数据
      tableData: [],
      customers: [],
      customerMaps: {},
      channels: [],
      channelsMaps: {},

      warehouses: [],
      warehouseMap: {},
      //收货弹窗
      receiptForm: {
        orderId: "",
        customerName: "",
        allArrival: 1,
        totalCarton: 0,
        actualArrivalQty: 0,
        arrivalCartonCodes: [],
        exceptionCartonCodes: [],
        radio: 2,
        warehouseId: ''
      },
      exceptionImg: [],
      goodsFormMore: {
        //批量收货
        test: ""
      },
      //异常信息查看
      dialogGoodsFormExceptionVisible: false,
      visiblePicture: false,
      exceptionCartonData: [],
      spImgArr: [],
      activeIndex: null, //当前展示图片的index

      dialogGoodsFormMoreVisible: false,
      dialogGoodsFormVisible: false,
      dialogGoodsVisible: false,
      dialogImageUrl: "",
      //tag标签
      inputVisible: false,
      arrivalCarton: "",
      inputVisible1: false,
      exceprtionCarton: "",
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      pageSize: 10,
      total: 0,
      currentPage: 1, //当前页
      rule: {
        actualArrivalQty: [
          { validator: validArrivalQty, trigger: "blur" },
          { required: true, message: "请输入到货箱数", trigger: "blur" }
        ]
      },
      editWarehouseForm: {
        orderIds: [],
        warehouseId: ""
      },
      dialogFormVisible1: false
    };
  },
  watch: {
    "abnormaData.practicalNum"(val) {
      if (
        this.abnormaData.exceptionType === "more" &&
        this.abnormaData.radio == "2" &&
        val > this.abnormaData.forecastNum
      ) {
        var len = val - this.abnormaData.forecastNum;
        this.spCartonList = [];
        for (let i = 0; i < len; i++) {
          this.spCartonList.push({
            cartonIndex: i + 1,
            skuArr: [
              {
                sku: "",
                zhName: "",
                enName: "",
                code: "",
                money: "",
                number: "",
                img: ""
              }
            ]
          });
        }
      }
    },
    "abnormaData.radio"(val) {
      if (
        this.abnormaData.exceptionType === "more" &&
        val == "2" &&
        this.abnormaData.practicalNum != 0 &&
        this.abnormaData.practicalNum > this.abnormaData.forecastNum
      ) {
        var len = this.abnormaData.practicalNum - this.abnormaData.forecastNum;
        this.spCartonList = [];
        for (let i = 0; i < len; i++) {
          this.spCartonList.push({
            cartonIndex: i + 1,
            skuArr: [
              {
                sku: "",
                zhName: "",
                enName: "",
                code: "",
                money: "",
                number: "",
                img: ""
              }
            ]
          });
        }
      }
    }
  },
  created() {
    setTimeout(() => {
      this.initData();
    }, 1000);
  },
  computed: {},
  methods: {
    reset() {
      this.queryForm = {
        warehouseIds: [],
        orderIds: [],
        refNumbers: [],
        status: "0",
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0
      };
      this.searchTask();
    },
    //tag标签
    dealExcepptionArrivaledClose(tag) {
      this.abnormaData.partReturnCartonsList.splice(
        this.abnormaData.partReturnCartonsList.indexOf(tag),
        1
      );
    },
    showReturnArrivaledInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveArrivaledTagInput.$refs.input.focus();
      });
    },
    handleReturnArrivaledInputConfirm() {
      let partReturnCartons = this.partReturnCartons;
      if (partReturnCartons.trim() == "") {
        return;
      }
      if (
        partReturnCartons &&
        this.abnormaData.partReturnCartonsList.indexOf(partReturnCartons) == -1
      ) {
        this.abnormaData.partReturnCartonsList.push(partReturnCartons);
      }
      this.inputVisible = false;
      this.partReturnCartons = "";
    },
    changeReturnCarton() {
      if (!this.abnormaData.returnCarton) {
        this.abnormaData.returnMethod = "part_return";
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview2(file) {
      this.dialogImageUrl2 = file.url;
      this.dialogVisible2 = true;
    },
    //增加
    handleAddSku() {
      this.spList.push({
        sku: "",
        zhName: "",
        enName: "",
        code: "",
        money: "",
        number: "",
        img: ""
      });
    },
    //删除
    handleDeleteSku(i, row) {
      this.spList.splice(i, 1);
    },

    handleAddCarton() {
      this.spCartonList.push({
        cartonIndex: "",
        skuArr: [
          {
            sku: "",
            zhName: "",
            enName: "",
            code: "",
            money: "",
            number: "",
            img: ""
          }
        ]
      });
    },
    //箱添加sku
    handleAddCartonSku(index, row) {
      row.push({
        sku: "",
        zhName: "",
        enName: "",
        code: "",
        money: "",
        number: "",
        img: ""
      });
    },
    //删除箱中sku
    handleDeleteCartonSku(i, row) {
      row.splice(i, 1);
    },
    //删除箱信息
    handleDeleteCarton(i, row) {
      this.spCartonList.splice(i, 1);
    },
    initData() {
      let _this = this;
      let urlArray = [
        this.findAllCustomerName(),
        this.findAllWarehouse(),
        this.findAllChannle()
      ]; // unknown # of urls (1 or more)

      this.$axios.all(urlArray).then(
        this.$axios.spread(function(customerData, warehouseData, channelData) {
          _this.initCustomerData(customerData);
          _this.initWarehouseData(warehouseData);
          _this.initChannelData(channelData);
          _this.query();
        })
      );
    },
    initWarehouseData(data) {
      let _this = this;
      _this.warehouses = data.data;
      _this.warehouses.forEach(a => {
        _this.warehouseMap[a.id] = a.name;
      });
    },
    initChannelData(data) {
      let _this = this;
      _this.channels = data.data;
      if (_this.channels.length > 0) {
        _this.channels.forEach(c => {
          _this.channelsMaps[c.id] = c.name;
        });
      }
    },
    initCustomerData(data) {
      let _this = this;
      if (data.data.success) {
        _this.customers = data.data.data;
        if (_this.customers.length > 0) {
          _this.customers.forEach(c => {
            _this.customerMaps[c.id] = c.name;
          });
        }
      }
    },
    //获取仓库
    findAllWarehouse() {
      return this.$request1.get(
        '/warehouse/staff',
        {
          withCredentials: true
        }
      );
    },
    //查询渠道
    findAllChannle() {
      return this.$request1.get(
        '/system/channel/all',
        {
          withCredentials: true
        }
      );
    },
    //查询客户
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll',
        {
          withCredentials: true
        }
      );
    },
    searchTask() {
      this.currentPage = 1;
      this.query();
    },
    query() {
      let _this = this;
      this.queryForm.orderIds = [];
      if (this.orderIds !== null && this.orderIds !== "") {
        let queryOrderIds = this.orderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.queryForm.orderIds.indexOf(item) == -1) {
              this.queryForm.orderIds.push(item);
            }
          }
        }
      }
      this.queryForm.refNumbers = [];
      if (this.refNumbers !== null && this.refNumbers !== "") {
        let queryrefNumbers = this.refNumbers.split(/[\n]+/);
        for (let item of queryrefNumbers) {
          if (item.trim() != "") {
            if (this.queryForm.refNumbers.indexOf(item) == -1) {
              this.queryForm.refNumbers.push(item);
            }
          }
        }
      }

      //过滤仓库
      let wlist = [];
      if (this.warehouses != null && this.warehouses.length > 0) {
        if (
          _this.queryForm.warehouseIds &&
          _this.queryForm.warehouseIds.length > 0
        ) {
          wlist = _this.queryForm.warehouseIds;
        } else {
          wlist = this.warehouses.map(a => a.id);
        }
      } else {
        wlist.push("NOT MATCHING");
      }

      this.$request1({
        method: 'post',
        url: '/operation/receipt/query',
        withCredentials: true,
        data: {
          orderIds: this.queryForm.orderIds,
          refNumbers: this.queryForm.refNumbers,
          customerIds: this.queryForm.customerIds,
          productIds: this.queryForm.productIds,
          status: this.queryForm.status,
          startDate: this.queryForm.startDate,
          endDate: this.queryForm.endDate,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          export: this.queryForm.export,
          warehouseIds: wlist
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            let taskData = data.data;
            this.total = data.total;
            if (this.total > 0) {
              this.tableData = taskData;
            } else {
              this.tableData = [];
              this.total = 0;
              if (data.data.length > 0) {
                this.editWarehouseForm.orderIds = data.data.toString();
                this.dialogFormVisible1 = true;
              }
            }
          } else {
            _this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          if (error.response) {
            _this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    //收货
    handleGoods(index, row) {
      this.dialogGoodsFormVisible = true;
      //处理到货业务
      this.receiptForm.orderId = row.orderId;
      this.receiptForm.orgOwner = row.orgOwner;
      this.receiptForm.customerName = this.customerMaps[row.orgOwner];
      this.receiptForm.totalCarton = row.totalCarton;
      this.receiptForm.actualArrivalQty = row.totalCarton - row.doneCarton;
      this.receiptForm.arrivaledQty = row.doneCarton;
      this.receiptForm.arrivalCartonCodes = [];
      this.receiptForm.exceptionCartonCodes = [];
      this.receiptForm.radio = 2;
      this.receiptForm.allArrival = 1;
      this.exceptionImg = [];
    },
    //检查是否全部到货
    checkArrival() {
      if (this.receiptForm.actualArrivalQty <= 0) {
        this.receiptForm.actualArrivalQty =
          this.receiptForm.totalCarton - this.receiptForm.arrivaledQty;
        return;
      }
      if (
        this.receiptForm.actualArrivalQty <
        this.receiptForm.totalCarton - this.receiptForm.arrivaledQty
      ) {
        this.receiptForm.allArrival = 0;
      } else if (
        this.receiptForm.actualArrivalQty >
        this.receiptForm.totalCarton - this.receiptForm.arrivaledQty
      ) {
        this.receiptForm.allArrival = 2;
        this.receiptForm.arrivalCartonCodes = [];
        this.receiptForm.exceptionCartonCodes = [];
        this.receiptForm.radio = 2;
        this.exceptionImg = [];
      } else {
        this.receiptForm.allArrival = 1;
        this.receiptForm.arrivalCartonCodes = [];
      }
    },
    //关闭收货框
    cancelReceipt() {
      this.dialogGoodsFormVisible = false;
      this.$refs.upload.clearFiles();
    },
    receiptDone() {
      //校验数据,待完善
      let receiptForm = this.receiptForm;
      if (receiptForm.actualArrivalQty <= 0) {
        this.$notify.error({
          title: "错误",
          message: "到货数量必须大于"
        });
        return;
      }
      if(!this.receiptForm.warehouseId){
        this.$notify.error({
          title: "错误",
          message: "收货仓库必选"
        });
        return;
      }

      if (
        receiptForm.actualArrivalQty <
        receiptForm.totalCarton - receiptForm.arrivaledQty
      ) {
        //判断是否异常
        if (receiptForm.radio == 2) {
          receiptForm.exceptionCartonCodes = [];
        }

        let lessNum =
          this.receiptForm.totalCarton -
          this.receiptForm.arrivaledQty -
          receiptForm.actualArrivalQty; //缺少的数量
        if (lessNum != receiptForm.arrivalCartonCodes.length) {
          this.$notify.error({
            title: "错误",
            message: "到货数量与到货箱号数量不同"
          });
          return;
        } else if (receiptForm.radio == 1) {
          //有异常
          if (receiptForm.exceptionCartonCodes.length == 0) {
            this.$notify.error({
              title: "错误",
              message: "请填写异常箱号"
            });
            return;
          } else if (
            receiptForm.exceptionCartonCodes.length >
            receiptForm.actualArrivalQty
          ) {
            this.$notify.error({
              title: "错误",
              message: "异常箱号数量必须小于等于到货数量"
            });
            return;
          } else if (this.exceptionImg.length == 0) {
            this.$notify.error({
              title: "错误",
              message: "请上传异常图片"
            });
            return;
          }
        }
      } else if (
        receiptForm.actualArrivalQty ==
        receiptForm.totalCarton - receiptForm.arrivaledQty
      ) {
        //有异常箱
        if (receiptForm.radio == 2) {
          receiptForm.exceptionCartonCodes = [];
        } else if (receiptForm.exceptionCartonCodes.length == 0) {
          this.$notify.error({
            title: "错误",
            message: "请填写异常箱号"
          });
          return;
        } else if (
          receiptForm.exceptionCartonCodes.length > receiptForm.actualArrivalQty
        ) {
          this.$notify.error({
            title: "错误",
            message: "异常箱号数量必须小于等于到货数量"
          });
          return;
        } else if (this.exceptionImg.length == 0) {
          this.$notify.error({
            title: "错误",
            message: "请上传异常图片"
          });
          return;
        }
      }

      let dataForm = this.getFormData(this.exceptionImg);
      dataForm.append("receiptForm", JSON.stringify(receiptForm));

      this.$request1({
        url: '/operation/receipt',
        method: 'POST',
        data: dataForm,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.dialogGoodsFormVisible = false;
            this.$notify({
              title: "成功",
              message: data.message,
              type: "success"
            });
            this.$refs.upload.clearFiles();
            setTimeout(() => {
              this.query();
            }, 1500);
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    getFormData(pic) {
      var formData = new FormData();
      pic.forEach((pic, index) => {
        formData.append(pic.uid, pic.raw);
      });
      return formData;
    },
    //转为异常单
    changeToException(row) {
      let orderId = row.orderId;
      this.$prompt("请输入异常原因?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator(value) {
          if (value == null || value.trim() == "") {
            return "请输入异常原因";
          }
          return true;
        }
      })
        .then(({ value }) => {
          this.$request1({
            url: '/operation/receipt/' + row.orderId + '/exception',
            method: 'POST',
            data: {
              exceptionMsg: value
            }
          })
            .then(response => {
              let data = response.data;
              if (data.success) {
                this.$notify({
                  title: "成功",
                  message: "操作成功",
                  type: "success"
                });
                this.query();
              } else {
                this.$notify.error({
                  title: "错误",
                  message: data.message
                });
              }
            })
            .catch(error => {
              this.$notify.error({
                title: "错误",
                message: error.response.data
              });
            });
        })
        .catch(() => {
          console.log("close");
        });
    },

    //下载
    handleDownload(index, row) {
      let url = '/operation/receipt/' + row.orderId + '/download/' + "210X297" + '?t=1';
      this.$windowOpen1(url);
    },
    handleArrivalToEditOrder(row) {
      this.$router.push({
        path: "/editorder",
        query: {
          orderId: row.orderId,
          editCarton: true
        }
      });
    },
    //转为正常单，多种处理情况
    handleChange(row) {
      this.abnormaData.forecastNum = row.totalCarton;
      this.abnormaData.receiptNum = row.doneCarton;

      this.dialogFormVisible = true;

      // this.$confirm("确定改为正常单?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {
      //     this.$request1({
      //       url: '/operation/receipt/' + //         row.orderId
      // + '/available',
      //       method: 'POST'
      //     })
      //       .then(response => {
      //         let data = response.data;
      //         if (data.success) {
      //           this.$notify({
      //             title: "成功",
      //             message: "操作成功",
      //             type: "success"
      //           });
      //           this.query();
      //         } else {
      //           this.$notify.error({
      //             title: "错误",
      //             message: data.message
      //           });
      //         }
      //       })
      //       .catch(error => {
      //         this.$notify.error({
      //           title: "错误",
      //           message: error.response.data
      //         });
      //       });
      //   })
      //   .catch(() => {
      //     console.log("close");
      //   });
    },
    //批量转为正常单
    handleChangeMore(index, row) {
      this.$alert(
        "<strong>温馨提示：</strong><p>异常收货订单已经转为正常单，请下载新的面单，并重新收货！</p>",
        "转单结果",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "下载面单",
          type: "warning",
          callback: action => {
            this.$notify.error({
              title: "错误",
              message: ""
            });
          }
        }
      );
    },
    //查看异常的信息
    exceptionLook(row) {
      let orderId = row.orderId;
      this.$request1({
        url: '/operation/receipt/' + orderId + '/exception',
        method: 'GET'
      })
        .then(response => {
          this.exceptionCartonData = response.data;
          this.dialogGoodsFormExceptionVisible = true;
        })
        .catch(error => {
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    getUrlArr(val) {
      this.visiblePicture = true;
      this.spImgArr != val && (this.spImgArr = val);
    },
    //图片组件获取当前index
    getActiveIndex(index) {
      this.activeIndex = index;
      this.$nextTick(function() {
        this.title =
          this.spImgArr.length > 0 && this.spImgArr[index].title
            ? this.spImgArr[index].title
            : "标题";
      });
      // console.log("图片组件获取当前index: " + index);
    },
    //上传图片
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogGoodsVisible = true;
    },

    handlePictureCardChange(file, fileList) {
      this.exceptionImg = fileList;
    },
    //tag标签
    handleArrivaledClose(tag) {
      this.receiptForm.arrivalCartonCodes.splice(
        this.receiptForm.arrivalCartonCodes.indexOf(tag),
        1
      );
    },
    showArrivaledInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveArrivaledTagInput.$refs.input.focus();
      });
    },
    handleArrivaledInputConfirm() {
      let arrivalCarton = this.arrivalCarton;
      if (
        arrivalCarton &&
        this.receiptForm.arrivalCartonCodes.indexOf(arrivalCarton) == -1
      ) {
        this.receiptForm.arrivalCartonCodes.push(arrivalCarton);
      }
      this.inputVisible = false;
      this.arrivalCarton = "";
    },
    handleExceptionClose(tag) {
      this.receiptForm.exceptionCartonCodes.splice(
        this.receiptForm.exceptionCartonCodes.indexOf(tag),
        1
      );
    },
    showExceptionInput() {
      this.inputVisible1 = true;
      this.$nextTick(_ => {
        this.$refs.saveExceptionTagInput.$refs.input.focus();
      });
    },
    handleExceptionInputConfirm() {
      let inputValue = this.exceprtionCarton;
      if (
        inputValue &&
        this.receiptForm.exceptionCartonCodes.indexOf(inputValue) == -1
      ) {
        this.receiptForm.exceptionCartonCodes.push(inputValue);
      }
      this.inputVisible1 = false;
      this.exceprtionCarton = "";
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    },
    editWarehouse() {
      if (this.editWarehouseForm.warehouseId == "") {
        this.$notify({
          title: '提示',
          message: '请选择仓库',
          type: 'warning'
        });
        return
      }
      this.$request1({
        url: '/order/edit/warehouse',
        method: 'POST',
        params: {
          orderId: this.editWarehouseForm.orderIds,
          warehouseCode: this.editWarehouseForm.warehouseId
        }
      })
        .then(response => {
          if (response.data.success) {
            this.$notify({
              title: '成功',
              type: 'success'
            });
            this.dialogFormVisible1 = false
            this.query();
          } else {
            this.$notify.error({
              title: '错误',
              message: response.data.message
            });
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/arrivalgoods.vue